import React, { useRef } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { Toaster } from "sonner";
import { Header } from "./components/Header";
import { AnnouncementBanner } from "./components/AnnouncementBanner";
import { HeroSection } from "./components/HeroSection";
import { ComparisonModule } from "./components/ComparisonModule";
import { ProductCategories } from "./components/ProductCategories";
import { ElectrificationSection } from "./components/ElectrificationSection";
import { HowItWorks } from "./components/HowItWorks";
import { WhyCompare } from "./components/WhyCompare";
import { Testimonials } from "./components/Testimonials";
import { InsightsSection } from "./components/InsightsSection";
import { Footer } from "./components/Footer";
import { toast } from "sonner";
import ComparePage from "./pages/ComparePage";
import AdminPage from "./pages/AdminPage";
import AboutPage from "./pages/AboutPage";
import TermsPage from "./pages/TermsPage";
import PrivacyPage from "./pages/PrivacyPage";
import HeatPumpHotWaterPage from "./pages/HeatPumpHotWaterPage";
import RebateChangesPage from "./pages/RebateChangesPage";
import BatteryDealPage from "./pages/BatteryDealPage";
import AreaPage from "./pages/AreaPage";
import BlogIndexPage from "./pages/BlogIndexPage";
import BlogPostPage from "./pages/BlogPostPage";
import NswHomeEnergySaverPage from "./pages/NswHomeEnergySaverPage";

const HomePage = () => {
  const compareRef = useRef(null);

  const scrollToCompare = () => {
    compareRef.current?.scrollIntoView({ behavior: 'smooth', block: 'center' });
  };

  const scrollToHowItWorks = () => {
    document.getElementById('how-it-works')?.scrollIntoView({ behavior: 'smooth' });
  };

  const handleShowOptions = (data) => {
    // Data is now saved to backend - this handler receives the response
    console.log('Enquiry submitted:', data);
  };

  const handleCompareProduct = (productId) => {
    scrollToCompare();
    toast.info(`Compare ${productId.replace('-', ' ')} options`, {
      description: "Select your postcode to see available options.",
    });
  };

  return (
    <div className="min-h-screen bg-white">
      <AnnouncementBanner />
      <Header onStartComparing={scrollToCompare} />
      <main>
        <HeroSection onCompareNow={scrollToCompare} onHowItWorks={scrollToHowItWorks} />
        <div ref={compareRef}>
          <ComparisonModule onShowOptions={handleShowOptions} />
        </div>
        <ProductCategories onCompare={handleCompareProduct} />
        <ElectrificationSection onCompareNow={scrollToCompare} />
        <HowItWorks />
        <WhyCompare />
        <Testimonials />
        <InsightsSection />
      </main>
      <Footer />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <Helmet defaultTitle="Compare Solar, Batteries, EV Chargers & Heat Pumps | CompareYourOptions.com.au">
        <meta
          name="description"
          content="Compare solar, batteries, EV chargers and heat pumps for your Australian home. Free, independent comparisons to help you cut power bills and access rebates."
        />
        <meta property="og:site_name" content="CompareYourOptions.com.au" />
        <meta property="og:type" content="website" />
      </Helmet>
      <BrowserRouter>
        <Toaster 
          position="top-center" 
          richColors 
          toastOptions={{
            style: {
              fontFamily: 'Inter, system-ui, sans-serif',
            },
          }}
        />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/compare" element={<ComparePage />} />
          <Route path="/admin" element={<AdminPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/terms" element={<TermsPage />} />
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route path="/hot-water-savings" element={<HeatPumpHotWaterPage />} />
          <Route path="/heat-pump-hot-water" element={<HeatPumpHotWaterPage />} />
          <Route path="/rebate-changes" element={<RebateChangesPage />} />
          <Route path="/solar-homes-changes" element={<RebateChangesPage />} />
          <Route path="/battery-deal" element={<BatteryDealPage />} />
          <Route path="/eofy-battery-deal" element={<BatteryDealPage />} />
          <Route path="/nsw-home-energy-saver" element={<NswHomeEnergySaverPage />} />
          <Route path="/nsw" element={<NswHomeEnergySaverPage />} />
          <Route path="/blog" element={<BlogIndexPage />} />
          <Route path="/blog/:slug" element={<BlogPostPage />} />
          <Route path="/:area" element={<AreaPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
